import { OptionType } from "./delivery-plan.interfaces";

export const deliveryStaticOptions: OptionType[] = [
  {
    value: "Delivery notices received / Delivery time updated in IMOS",
    label: "Delivery notices received / Delivery time updated in IMOS",
  },
];

export const redeliveryStaticOptions: OptionType[] = [
  {
    value: "Redelivery notices, bunker deductions from confirmation received",
    label: "Redelivery notices, bunker deductions from confirmation received",
  },
  {
    value: "Redelivery notices tendered in a timely manner (as per CP terms and basis most accurate prospects)",
    label: "Redelivery notices tendered in a timely manner (as per CP terms and basis most accurate prospects)",
  },
];